module.exports = __webpack_public_path__ + "static/img/img-kf.b761e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-kf.png
// module id = k2/M
// module chunks = 0